export { default } from "./cancerTypeBlock";
export type { CancerTypeBlockProps } from "./cancerTypeBlock";
